export default __webpack_public_path__ + "static/bg-chronicle-2-efb00d7466bae53760e9c219dafb837f.png";